import {useEffect, useMemo} from 'react'
import {useStatesGlobal} from '../../../../_gori/helpers/components/StatesGlobalProvider'
import {OPTION_PACKAGE_TYPE} from '../core/_const'
import {cloneDeep, isEmpty} from 'lodash'
import {useIntl} from 'react-intl'

export const useOrderFilter = () => {
  const intl = useIntl()
  const {statesGlobal, getPackages} = useStatesGlobal()

  const carriers = statesGlobal.carriers
  const packages = statesGlobal.packages

  useEffect(() => {
    getPackages()

    return () => {}
  }, [getPackages])

  const optionsStandardPackage = useMemo(() => {
    const _options: any = []
    if (isEmpty(carriers)) return []
    Object.values(carriers).forEach((carrier: any) => {
      if (carrier.status && carrier.package_types) {
        const arr = carrier.package_types.map((item) => ({label: item.label, value: item.value}))
        _options.push(...arr)
      }
    })

    // Remove duplicate values
    const unionOptions = _options.reduce((acc, curr) => {
      if (!acc.some((item) => item.value === curr.value)) {
        acc.push(curr)
      }
      return acc
    }, [] as {label: string; value: string}[])

    return unionOptions
  }, [carriers])

  const optionPackages = useMemo(() => {
    if (isEmpty(packages)) return []
    return (
      packages &&
      packages.map((item: any) => ({
        label: `${item.name} ${item.length}*${item.width}*${item.height}`,
        value: item.id.toString(),
      }))
    )
  }, [packages])

  const optionPackageInfo = useMemo(() => {
    return [
      {
        label: intl.formatMessage({id: OPTION_PACKAGE_TYPE.CARRIER_STANDARD_PACKAGE.label}),
        value: OPTION_PACKAGE_TYPE.CARRIER_STANDARD_PACKAGE.value,
        children: optionsStandardPackage,
      },
      {
        label: intl.formatMessage({id: OPTION_PACKAGE_TYPE.CUSTOM_PACKAGE.label}),
        value: OPTION_PACKAGE_TYPE.CUSTOM_PACKAGE.value,
        children: optionPackages,
      },
    ]
  }, [optionPackages, optionsStandardPackage, intl])

  const optionsService = useMemo(() => {
    if (isEmpty(carriers)) return
    const serviceEnable = Object.values(cloneDeep(carriers)).filter((value: any) => value?.status)

    const _optionsService = serviceEnable.map((value: any) => ({
      label: value.visuals?.display_name,
      value: `${value.carrier}_${value.service}`,
    }))

    return [{label: intl.formatMessage({id: 'NONE'}), value: 'none'}, ..._optionsService]
  }, [carriers, intl])

  const optionsDomesticService = useMemo(() => {
    if (isEmpty(carriers)) return
    const serviceEnable = Object.values(cloneDeep(carriers)).filter((value: any) => value?.status)

    const _optionsService = serviceEnable
      .filter((value: any) => !value.international)
      .map((value: any) => ({
        label: value.visuals?.display_name,
        value: `${value.carrier}_${value.service}`,
      }))

    return [{label: intl.formatMessage({id: 'NONE'}), value: 'none'}, ..._optionsService]
  }, [carriers, intl])

  return {
    optionPackageInfo,
    optionsService,
    optionsDomesticService,
  }
}
